import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { environment } from "../environments/environment.production";
import { EstatusVehiculoResponse } from "../pojos/estatusVehiculoResponse";
import {DefaultErrorMessage, ErrorMessages } from "../components/catalogoErrores/error-messages";

@Injectable({
  providedIn: 'root'
})
export class ConsultarEstatusVehiculoService {
 private readonly endPoint = `${environment.HOST}/consultarEstatusVehiculoFisica`;
 // private readonly endPoint = `${environmentDevelopment.HOST}/consultarVehiculo`;
  constructor(
    private http: HttpClient,
   // private errorHandler: ErrorHandlerService // Servicio opcional para manejo centralizado
  ) {}
  consultarEstatusVehiculo(strNiv: string, strPlaca: string): Observable<EstatusVehiculoResponse> {
 if (!strNiv?.trim()) {
    return throwError(() => this.createValidationError('NIV no puede estar vacío'));
  }
  if (!strPlaca?.trim()) {
    return throwError(() => this.createValidationError('Placa no puede estar vacía'));
  }

  const params = new HttpParams()
    .set('strNiv', strNiv)
    .set('strPlaca', strPlaca);

  return this.http.get<EstatusVehiculoResponse>(this.endPoint, { params }).pipe(
    catchError(error => {
      const customError = {
        originalError: error,
        timestamp: new Date().toISOString(),
        userMessage: error.error?.descripcionCodigo ||
          ErrorMessages[error.error?.idCodigo] ||
          ErrorMessages[error.status] ||
          DefaultErrorMessage,
        context: {
          endpoint: this.endPoint,
          params: { strNiv, strPlaca }
        }

      };
      console.log();
      return throwError(() => customError);
    })
  );
  }

  private createValidationError(message: string): any {
    return {
      type: 'VALIDATION_ERROR',
      message,
      timestamp: new Date().toISOString()
    };
  }
}


